import { syncSystemBehaviors, syncSystemTrackingTypes } from "helpers/enums";
import { getInitialStateFromConfig } from "helpers/form";
import { requiredField } from "helpers/validators";
import { list } from "sources/books/employees";

const config = {
    userId: {
        label: "Пользователь",
        inputProps: { name: "userId" },
        filterPropName: "fullNameOrEmail",
        menuPortalTarget: document.body,
        propName: "fullNameOrEmail",
        url: list,
        required: true,
        validators: [requiredField],
    },
    key: {
        label: "Ключ ВИС",
        required: true,
        validators: [requiredField],
        inputProps: { name: "key", autoComplete: "off" },
    },
    behavior: {
        label: "Поведение",
        inputProps: { name: "behavior" },
        menuPortalTarget: document.body,
        propName: "behavior",
        required: true,
        validators: [requiredField],
        options: syncSystemBehaviors,
    },
    trackingType: {
        label: "Тип изменения для отслеживания",
        inputProps: { name: "trackingType" },
        menuPortalTarget: document.body,
        required: true,
        validators: [requiredField],
        options: syncSystemTrackingTypes,
    },
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
